import React from 'react';
import {Select} from '@mantine/core';
import {Stack} from 'src/design/atoms/Stack';
import {TaskTypeEnum} from 'src/api/ProactApiClient';
import {useGetTaskDefinitionListQuery} from 'src/redux/queries/taskDefinition';
import type {TriggerEditorProps} from './TriggerCard';

export const TriggerTaskCompletionEditor: React.FC<TriggerEditorProps> = ({
  trigger,
  onTriggerChange,
}) => {
  const {data: tasks, isLoading} = useGetTaskDefinitionListQuery();

  const options =
    tasks?.data?.map(task => ({
      value: String(task.id),
      label: `${TaskTypeEnum[task.taskType]} - ${task.subject}`,
    })) ?? [];

  const handleTaskChange = (value: string | null) => {
    onTriggerChange({
      ...trigger,
      triggerTaskDefinitionId: value ? Number(value) : undefined,
    });
  };

  return (
    <Stack gap="md">
      <Select
        label="Task definition"
        description="The workflow will trigger when this task is completed."
        data={options}
        value={
          trigger.triggerTaskDefinitionId
            ? String(trigger.triggerTaskDefinitionId)
            : null
        }
        onChange={handleTaskChange}
        disabled={isLoading}
        searchable
      />
    </Stack>
  );
};
